import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.707 17.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1-.097-.112l-.071-.11-.054-.114-.035-.105-.025-.117-.007-.06L3 12l.003-.075.017-.126.03-.111.044-.111.052-.098.067-.096.08-.09 6-6a1 1 0 0 1 1.414 1.414L6.414 11H21a8 8 0 0 1 0 16H10a1 1 0 1 1 0-2h11a6 6 0 1 0 0-12H6.414z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconArrowUUpLeft = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowUUpLeft);
export default Memo;
